export const APP_SUBSCRIPTION_QUERY_KEY = 'appSubscriptionQueryKey'
export const CURRENT_BUSINESS_MAX_EMPLOYEES_QUERY_KEY = 'currentBusinessMaxEmployeesQueryKey'
export const CURRENT_BUSINESS_SUBSCRIPTION_QUERY_KEY = 'currentBusinessSubscriptionQueryKey'
export const APP_SUBSCRIPTION_PRODUCTS_QUERY_KEY = 'appSubscriptionProductsQueryKey'
export const PLAN_TYPES_QUERY_KEY = 'planTypesQueryKey'
